module.exports = __webpack_public_path__ + "img/mbeans.e9d14fef.svg";